import { toPng } from 'html-to-image';

export const uploadCanvasImage = async (
    canvas: React.RefObject<HTMLDivElement>,
    download: boolean = false,
) => {
    if (!canvas || typeof canvas !== 'object' || !('current' in canvas) || !canvas.current) return;
    console.log('Uploading canvas image');
    const root = canvas.current;

    const removedElements: { el: HTMLElement; prevDisplay: string }[] = [];
    const removedSvgElements: { svg: SVGElement; parent: HTMLElement }[] = [];
    const clearedBackgrounds: { el: HTMLElement }[] = [];
    const removedButtons: { container: HTMLElement; button: HTMLButtonElement }[] = [];

    root.querySelectorAll<HTMLElement>('*').forEach((el) => {
        const classList = Array.from(el.classList);
        const isSlotEmpty = classList.some((cls) => cls.includes('Slot_empty'));

        if (isSlotEmpty) {
            const svg = el.querySelector('svg');
            if (svg) {
                removedSvgElements.push({ svg, parent: el });
                svg.remove();
            }
        }

        if (isSlotEmpty) {
            clearedBackgrounds.push({ el });
            el.style.setProperty('background-color', 'transparent', 'important');
        }

        if (classList.some((cls) => cls.includes('LayoutSwitcher_layoutSwitcher'))) {
            removedElements.push({
                el,
                prevDisplay: el.style.display,
            });
            el.style.display = 'none';
        }

        if (classList.some((cls) => cls.includes('CanvasOverlayActions_container'))) {
            removedElements.push({
                el,
                prevDisplay: el.style.display,
            });
            el.style.display = 'none';
        }

        if (classList.some((cls) => cls.includes('TextContainer_block_container'))) {
            el.querySelectorAll<HTMLButtonElement>('button').forEach((button) => {
                removedButtons.push({ container: el, button });
                button.remove();
            });
        }
    });

    const styledElements: {
        el: HTMLElement;
        originalBorder: string | null;
        originalBorderRadius: string | null;
    }[] = [];
    root.querySelectorAll<HTMLElement>('*').forEach((el) => {
        const originalBorder = el.style.getPropertyValue('border');
        const originalBorderRadius = el.style.getPropertyValue('border-radius');

        el.style.setProperty('border', 'none', 'important');
        el.style.setProperty('border-radius', '0', 'important');

        styledElements.push({ el, originalBorder, originalBorderRadius });
    });

    try {
        const dataUrl = await toPng(root);

        if (download) {
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = 'canvas.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        const res = await fetch(dataUrl);
        const blob = await res.blob();
        const file = new File([blob], 'canvas.png', { type: 'image/png' });

        return file;
    } catch (error) {
        console.error('Ошибка при сохранении canvas:', error);
    } finally {
        removedSvgElements.forEach(({ svg, parent }) => {
            parent.appendChild(svg);
        });

        clearedBackgrounds.forEach(({ el }) => {
            el.style.removeProperty('background-color');
        });

        removedElements.forEach(({ el, prevDisplay }) => {
            el.style.display = prevDisplay || '';
        });

        styledElements.forEach(({ el, originalBorder, originalBorderRadius }) => {
            if (originalBorder) {
                el.style.setProperty('border', originalBorder);
            } else {
                el.style.removeProperty('border');
            }

            if (originalBorderRadius) {
                el.style.setProperty('border-radius', originalBorderRadius);
            } else {
                el.style.removeProperty('border-radius');
            }
        });

        removedButtons.forEach(({ container, button }) => {
            container.appendChild(button);
        });
    }
};

export const uploadCanvasImageFast = async (containerRef: React.RefObject<HTMLDivElement>) => {
    if (!containerRef.current) return;

    const canvasEl = containerRef.current.querySelector('canvas');
    if (!canvasEl) return;

    // Используем нативный метод canvas
    const dataUrl = canvasEl.toDataURL('image/png');

    const res = await fetch(dataUrl);
    const blob = await res.blob();
    const file = new File([blob], 'canvas.png', { type: 'image/png' });

    return file;
};
